import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=2dc5699a&scoped=true"
import script from "./Payouts.vue?vue&type=script&lang=js"
export * from "./Payouts.vue?vue&type=script&lang=js"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=2dc5699a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5699a",
  null
  
)

export default component.exports